/* eslint-disable react-hooks/exhaustive-deps */
import cn from 'classnames';
import { Formik, FormikProps } from 'formik';
import { History } from 'history';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { IMAGES } from 'src/appConfig/images';
import { PATHS } from 'src/appConfig/paths';
import { Button, Form, Image, Input, InputPassword,  View } from 'src/components/common';
import Footer from 'src/components/Footer';
import { signInAsync } from 'src/redux/auth/actions';
import { IRootState } from 'src/redux/rootReducer';
import { ErrorService, Navigator, Yup } from 'src/services';
import './styles.scss';

type FormValue = {
  email: string;
  password: string;
};

const INTIAL: FormValue = { email: '', password: '' };

const Signin: React.FC<Props> = ({ error, isSigningIn, onSignIn }) => {
  const formRef = useRef<FormikProps<FormValue>>(null);

  useEffect(() => {
    if (error) handleError(error);
  }, [error]);

  const handleLogin = (values: FormValue) => {
    const { email, password } = values;
    onSignIn({ username: email, password });
  };

  // const handleLoginAsGuest = (event: MouseEvent) => {
  //   event.preventDefault();
  //   onSetGuest(true);
  // };

  const handleError = (error: AuthError) => {
    switch (error.code) {
      case 'NotAuthorizedException':
        return formRef.current.setErrors({ email: ' ', password: ErrorService.MESSAGES.incorrectAccount });

      case 'UserNotFoundException':
        return formRef.current.setErrors({ email: ErrorService.MESSAGES.accountNotExist });

      // this case is handled in auth saga, skip here to not show toast message
      case 'UserNotConfirmedException':
        return;

      default:
        return ErrorService.handler(error);
    }
  };

  // =========================== FORGOT PASSWORD ===========================
  const handleForgotPassword = (data: FormValue) => {
    Navigator.navigate(PATHS.forgotPassword, { email: data.email });
  };
  const handleFirstTimeLogin = (data: FormValue) => {
    Navigator.navigate(PATHS.firstTimeLogin, { email: data.email, action: 'FIRST_TIME' });
  };
  // =========================== SCHEMA ===========================
  const SigninSchema = Yup.object().shape({
    email: Yup.string().required().email(),
    password: Yup.string().required(),
  });

  return (
    <View className="ctn-uam" flexGrow={1}>
      <Image className="ctn-uam__image" src={IMAGES.backgroundLogin} />
      <View className="container" flexGrow={1}>
        <View className="ctn-uam__container" flexGrow={1}>
          <h1 className={cn('ctn-uam__title mb-8')}>{'Welcome!'}</h1>

          <Formik initialValues={INTIAL} onSubmit={handleLogin} validationSchema={SigninSchema} innerRef={formRef}>
            {({ values, errors, touched, getFieldProps, handleSubmit }) => (
              <Form onSubmit={handleSubmit} autoComplete="off" className="ctn-uam__form">
                <Input
                  label="Email"
                  placeholder="Email"
                  errorMessage={touched.email ? errors.email : ''}
                  containerClassName="mb-16"
                  {...getFieldProps('email')}
                />
                <InputPassword
                  label="Password"
                  placeholder="Password"
                  errorMessage={touched.password ? errors.password : ''}
                  containerClassName="mb-16"
                  {...getFieldProps('password')}
                />
                <View isRow justify="space-between" className=" mb-40">
                  <Button
                    type="button"
                    variant="link-primary"
                    className="ctn-uam__link"
                    onClick={() => handleFirstTimeLogin(values)}>
                    FIRST TIME LOGIN?
                  </Button>
                  <Button
                    type="button"
                    variant="link-primary"
                    className="ctn-uam__link"
                    onClick={() => handleForgotPassword(values)}>
                    FORGOT PASSWORD?
                  </Button>
                </View>

                <Button type="submit" className="mb-8" isLoading={isSigningIn}>
                  LOG IN
                </Button>
              </Form>
            )}
          </Formik>
          <Footer className="ctn-uam__footer" />
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IRootState) => ({
  isSigningIn: state.auth.isSigningIn,
  error: state.auth.error,
});

const mapDispatchToProps = {
  onSignIn: signInAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
